import React, {Component} from "react";

export default class ProductivityInsights extends Component {


    render() {
        return (
            <>
                TODO: Display the users productivity this might be colliding with projects insights

            </>
        );
    }
}